module.exports = __webpack_public_path__ + "static/img/Gold Nova Master.19a3717.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/csgo/ranks/Gold Nova Master.png
// module id = ukYl
// module chunks = 38